import React, { useEffect, useState } from 'react';
import { Table, Spin ,Row,Col,Typography} from 'antd';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { convertDateToUserTimezone } from '../Components/Utility';  // Assuming this is where it's located
import { DateFormat,DateTimeFormat } from '../Components/Constant';  // Assuming your date format constant is here

const { Title } = Typography;

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const fetchAuditLogs = new ApiService(`${BASE_URL}/setup_audit_logs`, {
        'Content-Type': 'application/json',
      }, 'GET');
      
      const response = await fetchAuditLogs.makeCall();
      console.log('audit logs response:', response);

      const formattedLogs = (response?.records || []).map((log) => ({
        id: log._id,
        date: convertDateToUserTimezone(log.created_at, DateFormat),
        user: log.user_id || 'Unknown',
        action: log.action || '—',
        section: log.target_type || '—',
        ip_address: log.ip_address || '',
        target_name: log.target_name || '—',
        target_type: log.target_type || '—',
        user_name: log.user_name || '—',

      }));

      setLogs(formattedLogs);

    } catch (error) {
      console.error('Failed to fetch audit logs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
    },
   

    {
      title: 'Target Name',
      dataIndex: 'target_name',
      key: 'target_name',
    },

    {
      title: 'Target type',
      dataIndex: 'target_type',
      key: 'target_type',
    },

  
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
    },
    {
      title: 'Section',
      dataIndex: 'section',
      key: 'section',
    },
     {
      title: 'User Name',
      dataIndex: 'user_name',
      key: 'user_name',
    },
  ];

  return (

    <Spin spinning={loading}>
      <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
            <Col>
              <Title level={4}>Audit Logs</Title>
            </Col>
           
          </Row>
      <Table

        columns={columns}
        dataSource={logs}
        rowKey={(record) => record.id}
        pagination={true}
      />
    </Spin>
  );
};

export default AuditLogs;
